import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { apiFetch } from "../api/client";
import { COLORS } from "../theme";
import Card from "../components/ui/Card";
import Btn from "../components/ui/Btn";
import IconBadge from "../components/ui/IconBadge";
import EstadoCarregando from "../components/ui/EstadoCarregando";
import EstadoVazio from "../components/ui/EstadoVazio";
import { dataLocal } from "../utils/tempo";

export default function Aprovacoes() {
  const { token } = useAuth();
  const [pendentes, setPendentes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processando, setProcessando] = useState(null);
  const [erro, setErro] = useState("");

  const carregar = useCallback(async () => {
    setLoading(true);
    setErro("");
    try {
      const data = await apiFetch("GET", "/api/ponto/hora-extra-pendentes", undefined, token);
      setPendentes(data);
    } catch (e) {
      setErro(e.message);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { carregar(); }, [carregar]);

  const aprovar = async (item) => {
    setProcessando(item.id);
    try {
      await apiFetch("POST", `/api/ponto/hora-extra/${item.id}/aprovar`, undefined, token);
      await carregar();
    } catch (e) {
      window.alert(e.message);
    } finally {
      setProcessando(null);
    }
  };

  const rejeitar = async (item) => {
    const motivo = window.prompt(`Motivo da recusa (opcional) — ${item.funcionario_nome}, ${item.horas}h de hora extra:`);
    if (motivo === null) return; // cancelou
    setProcessando(item.id);
    try {
      await apiFetch("POST", `/api/ponto/hora-extra/${item.id}/rejeitar`, { motivo }, token);
      await carregar();
    } catch (e) {
      window.alert(e.message);
    } finally {
      setProcessando(null);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: COLORS.text, margin: "0 0 4px", letterSpacing: "-0.02em" }}>
          Hora Extra
        </h1>
        <p style={{ fontSize: 13.5, color: COLORS.textMid, margin: 0 }}>
          Horas extras detectadas automaticamente, aguardando sua aprovação para entrar no banco de horas.
        </p>
      </div>

      {loading ? (
        <Card style={{ padding: 0 }}><EstadoCarregando /></Card>
      ) : erro ? (
        <Card><p style={{ fontSize: 13.5, color: COLORS.danger, margin: 0 }}>{erro}</p></Card>
      ) : pendentes.length === 0 ? (
        <Card style={{ padding: 0 }}><EstadoVazio icon="checkCircle" texto="Nenhuma hora extra pendente no momento." /></Card>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {pendentes.map((item) => (
            <Card key={item.id}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, flexWrap: "wrap" }}>
                <div style={{ display: "flex", gap: 14, flex: 1, minWidth: 220 }}>
                  <IconBadge icon="clock" cor={COLORS.warning} size={36} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14.5, fontWeight: 700, color: COLORS.text, marginBottom: 4 }}>
                      {item.funcionario_nome}
                    </div>
                    <div style={{ fontSize: 12.5, color: COLORS.textMid }}>
                      Trabalhou <strong>{item.horas}h</strong> além do previsto no dia {dataLocal(item.data)}. Só entra no
                      saldo do banco de horas se você aprovar.
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                  <Btn
                    variant="secondary"
                    onClick={() => rejeitar(item)}
                    disabled={processando === item.id}
                    style={{ borderColor: COLORS.danger, color: COLORS.danger }}
                  >
                    Recusar
                  </Btn>
                  <Btn onClick={() => aprovar(item)} disabled={processando === item.id}>
                    {processando === item.id ? "..." : "Aprovar"}
                  </Btn>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
